import actionCreatorFactory from "typescript-fsa";

import {Ganymede} from "@slices/Ganymede/ClientManager";
import {routeActions} from "src/utils/router";


const actionCreator = actionCreatorFactory('routes/projects');

export const projectsRoute = routeActions(actionCreator);

export const getProjects =
  actionCreator.async<void, Ganymede.Project[]>('GET_PROJECTS');

export const createProjectClicked = actionCreator('CREATE_PROJECT_CLICKED');
export const cancelCreateClicked = actionCreator('CANCEL_CREATE_CLICKED');

export const newProjectNameChanged =
  actionCreator<string>('NEW_PROJECT_NAME_CHANGED');

export const createProjectSubmitted =
  actionCreator('CREATE_PROJECT_SUBMITTED');

export const createProject = actionCreator.async<{
  name: string;
}, Ganymede.Project>('CREATE_PROJECT');



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/routes/projects/Projects.actions.ts